<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>

    <el-row class="filter">
      <div
        style="
          width: 80%;
          margin: 0 auto;
          margin-top: 20px;
          margin-bottom: 20px;
        "
      >
        <el-form
          ref="form"
          :model="form"
          label-width="200px"
          class="demo-ruleForm"
          :label-width="formLabelWidth"
        >
          <el-form-item label="是否开启设备分播无异常波次一键打包:">
            <el-switch v-model="form.check_one" @change="change1"> </el-switch>
          </el-form-item>

          <el-form-item label="一键打包是否开启录入件数校验:">
            <el-switch
              ref="co_nv"
              v-model="form.check_one_num_valid"
              :disabled="!form.check_one"
              @change="change3"
            >
            </el-switch>
          </el-form-item>

          <el-form-item label="改标波次必须通过波次核查才能校验:">
            <el-switch v-model="form.label_must_hecha" @change="change2">
            </el-switch>
          </el-form-item>
          <el-form-item label="质检和售后波次必须通过波次核查才能校验:">
            <el-switch
              v-model="form.quality_inspection_must_checked"
              @change="change6"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="必须通过拣货或核查才能校验:">
            <el-switch v-model="form.picking_and_hecha" @change="change4">
            </el-switch>
          </el-form-item>
          <el-form-item label="拆分发货剩余商品是否允许自动完成打包:">
            <el-switch
              v-model="form.wp_split_auto_pack_remaining"
              @change="change5"
            >
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <el-row>
      <wave-check-setting></wave-check-setting>
    </el-row>
  </div>
</template>

<script>
import HeaderTabs from "./components/HeaderTabs";
import WaveCheckSetting from "./WaveCheckSetting";
export default {
  components: { HeaderTabs, WaveCheckSetting },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData();
    });
  },
  data() {
    return {
      form: {
        only_dabiao: false,
        today_full_allot: false,
        quality_dabiao: false,
        label_dabiao: false,
        check_one_num_valid: false,
        picking_and_hecha: false,
        wp_split_auto_pack_remaining: false,
      },
      loading: false,
      tableLoading: false,
      url: "/erp/WavePicking/CheckSetting",
      filterFold: false,
      supplyData: null,
      origin: 1,
      origin_txt: 1,
      formLabelWidth: "300px",
    };
  },
  computed: {
    filteredForm() {
      for (let key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.get(this.url, this.filteredForm).then(res => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form = res.data.data;
          this.origin = res.data.data.origin;
          this.origin_txt = res.data.data.origin_txt;
        }
      });
    },
    change1($e) {
      this.onSubmit($e, 1);
    },
    change2($e) {
      this.onSubmit($e, 2);
    },
    change3($e) {
      this.onSubmit($e, 3);
    },
    change4($e) {
      this.onSubmit($e, 4);
    },
    change5($e) {
      this.onSubmit($e, 5);
    },
    change6($e) {
      this.onSubmit($e, 6);
    },
    onSubmit($e, type) {
      this.form.origin = this.origin;
      let msg = "";
      if (type == 1) {
        if ($e === true) {
          msg = "是否确认开启一件打包？";
        } else {
          msg = "是否确认关闭一件打包？";
        }
      }
      if (type == 2) {
        if ($e === true) {
          msg = "是否确认开启改标必须通过波次核查？";
        } else {
          msg = "是否确认关闭改标必须通过波次核查？";
        }
      }

      if (type == 3) {
        if ($e === true) {
          msg = "是否确认开启一件打包录入件数校验？";
        } else {
          msg = "是否确认关闭一件打包录入件数校验？";
        }
      }
      if (type == 4) {
        if ($e === true) {
          msg = "是否确认开启必须通过拣货或核查才能校验？";
        } else {
          msg = "是否确认关闭必须通过拣货或核查才能校验？";
        }
      }
      if (type == 5) {
        if ($e === true) {
          msg = "是否确认开启“拆分发货剩余商品是否允许自动完成打包”？";
        } else {
          msg = "是否确认关闭“拆分发货剩余商品是否允许自动完成打包”？";
        }
      }
      if (type == 6) {
        if ($e === true) {
          msg = "是否确认开启“质检和售后波次必须通过波次核查才能校验”？";
        } else {
          msg = "是否确认关闭“质检和售后波次必须通过波次核查才能校验”？";
        }
      }

      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // console.log($e, type);
          this.fucking($e, type);
          // return true;
          this.$http.post(this.url, this.filteredForm).then(res => {
            setTimeout(() => {
              this.loading = false;
            }, 200);
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success("修改成功");
            }
          });
        })
        .catch(() => {
          if (type == 1) {
            this.form.check_one = !$e;
          }
          if (type == 2) {
            this.form.label_must_hecha = !$e;
          }
          if (type == 3) {
            this.form.check_one_num_valid = !$e;
          }
          if (type == 4) {
            this.form.picking_and_hecha = !$e;
          }
          if (type == 5) {
            this.form.wp_split_auto_pack_remaining = !$e;
          }
          if (type == 6) {
            this.form.quality_inspection_must_checked = !$e;
          }
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    fucking($e, type) {
      if (type != 1) {
        return false;
      }
      // 一起开启关闭录入件数校验
      this.$set(this.form, "check_one_num_valid", $e);
      // 关闭的话还要禁用录入件数校验
      if ($e === false) {
        this.$refs.co_nv.disabled = true;
      }
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/CheckSetting.vue